import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgViber = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <g fill="none" fillRule="evenodd">
      <rect width={23.413} height={23.413} fill="#7D519E" rx={11.707} />
      <path
        stroke="#FFF"
        d="m8.024 19.198 1.38-1.558.285.062c.42.09.85.137 1.287.137h1.784a6.043 6.043 0 0 0 0-12.086h-1.784A6.043 6.043 0 0 0 7.788 16.93l.236.146v2.12z"
      />
      <path
        fill="#FFF"
        d="M10.433 10.277c-.36.29-.619.36-.537.919.081.558.562 1.189.778 1.376.216.187 1.104 1.015 1.503 1.081.4.066.64-.078.727-.217a4.6 4.6 0 0 1 .42-.51c.246-.254.532-.254.857 0 .325.253.836.641 1.533 1.163.329.239.329.57 0 .991-.33.422-.62.73-.875.923-.433.173-.881.117-1.345-.167-.697-.426-2.24-1.043-3.48-2.4-.826-.905-1.628-2.108-2.407-3.61-.228-.69-.228-1.174 0-1.447.228-.274.523-.518.884-.734.38-.172.683-.112.911.18.228.291.592.787 1.092 1.486.2.45.18.772-.06.966z"
      />
      <path
        stroke="#FFF"
        d="M11.992 9.347c1.822-.07 2.692.757 2.613 2.479m-2.649-3.937c2.89-.11 4.272 1.201 4.145 3.934"
      />
    </g>
  </svg>
);
const Memo = memo(SvgViber);
export default Memo;
